<template>
  <b-card no-body class="border-top-0 border-left-0 border-right-0 rounded-0 seat-navigation-accordion-block">
    <b-card-header
      header-tag="header"
      class="p-0 border-0 rounded-0 bg-transparent"
      role="tab"
    >
      <button
        v-b-toggle="isOpen ? undefined : segment.segmentId"
        class="w-100 btn btn-ghost d-flex align-items-center"
        style="gap: 5px"
        @click="onOpen"
      >
        <vb-icon
          name="check_circle"
          :color="everyoneSeated ? color_success : '#adb5bd'"
          :size="16"
          :icon_style="{
            '--color': everyoneSeated ? color_success : '#adb5bd',
          }"
        ></vb-icon>
        <span :class="`flex-grow text-left segment-label ${isOpen ? 'semibold' : ''}`">
          {{ formatSegmentLabel(segment) }}
        </span>
        <div class="seat-nav-chevron-col">
          <vb-icon
            name="chevron-down"
            :size="14"
            :icon_style="{ transform: `rotate(${isOpen ? 180 : 0}deg)` }"
          ></vb-icon>
        </div>
      </button>
    </b-card-header>
    <b-collapse :id="segment.segmentId" :visible="isOpen" role="tabpanel">
      <b-card-body class="pt-1">
        <div class="d-none d-lg-flex d-xl-flex flex-column" style="gap: 5px">
          <slot name="flight"></slot>
          <slot name="deck"></slot>
          <slot name="passengers"></slot>
        </div>
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
import { formatSegmentLabel } from "@liveflight/utilities/mixins";
import { color_success } from "@liveflight/resources/colors";

export default {
  name: "seat-navigation-accordion-block",
  props: {
    segment: Object,
    everyoneSeated: Boolean,
    isOpen: Boolean,
    onOpen: Function,
  },
  data() {
    return {
      color_success,
    };
  },
  methods: {
    formatSegmentLabel,
  },
};
</script>

<style lang="scss" scoped>
  .seat-navigation-accordion-block {
    .segment-label {
      color: $text;
      font-size: 16px;
      word-spacing: 4px;
      margin-left: 6px;
    }
    .seat-nav-chevron-col {
      width: 24px;
      text-align: center;
      flex-shrink: 0;
      .vb-icon {
        display: inline-block;
      }
    }
  }
</style>
